module.exports = __webpack_public_path__ + "img/Weapon_58.d074e3d4.png";